var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16667 2.33333C0.525 2.33333 0 1.80833 0 1.16667C0 0.525 0.525 0 1.16667 0H19.8333C20.475 0 21 0.525 21 1.16667C21 1.80833 20.475 2.33333 19.8333 2.33333H1.16667ZM1.16667 8.16667H19.8333C20.475 8.16667 21 7.64167 21 7C21 6.35833 20.475 5.83333 19.8333 5.83333H1.16667C0.525 5.83333 0 6.35833 0 7C0 7.64167 0.525 8.16667 1.16667 8.16667ZM1.16667 14H19.8333C20.475 14 21 13.475 21 12.8333C21 12.1917 20.475 11.6667 19.8333 11.6667H1.16667C0.525 11.6667 0 12.1917 0 12.8333C0 13.475 0.525 14 1.16667 14Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.2b6b6e588a76f818cd853636142014bb.svg";
export { ForwardRef as ReactComponent };